import { render, staticRenderFns } from "./OrderDetailsDesignHistory.vue?vue&type=template&id=7b887251"
import script from "./OrderDetailsDesignHistory.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDesignHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsDesignHistory.vue?vue&type=style&index=0&id=7b887251&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports